import React from 'react';
import { motion } from 'framer-motion';
import './OnScreenKeyboard.css';

const OnScreenKeyboard = ({ onKeyPress, onClose, currentText = '' }) => {
  // Email-optimized keyboard layout - organized and centered
  const keys = [
    ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'],
    ['q', 'w', 'e', 'r', 't', 'y', 'u', 'i', 'o', 'p'],
    ['a', 's', 'd', 'f', 'g', 'h', 'j', 'k', 'l', '⌫'],
    ['z', 'x', 'c', 'v', 'b', 'n', 'm'],
    ['@', '.', '-', '_', '.com', '@gmail.com', '@outlook.com', 'OK']
  ];

  const handleKeyPress = (key, event) => {
    // Prevent event bubbling to avoid closing the keyboard
    if (event) {
      event.stopPropagation();
    }

    if (key === '⌫') {
      onKeyPress('Backspace');
    } else if (key === 'OK') {
      onKeyPress('OK');
    } else if (key === 'com') {
      // Special handling for .com shortcut
      onKeyPress('.');
      onKeyPress('c');
      onKeyPress('o');
      onKeyPress('m');
    } else if (key === 'gmail.com') {
      // Special handling for gmail.com suggestion
      onKeyPress('@');
      onKeyPress('g');
      onKeyPress('m');
      onKeyPress('a');
      onKeyPress('i');
      onKeyPress('l');
      onKeyPress('.');
      onKeyPress('c');
      onKeyPress('o');
      onKeyPress('m');
    } else if (key === 'outlook.com') {
      // Special handling for outlook.com suggestion
      onKeyPress('@');
      onKeyPress('o');
      onKeyPress('u');
      onKeyPress('t');
      onKeyPress('l');
      onKeyPress('o');
      onKeyPress('o');
      onKeyPress('k');
      onKeyPress('.');
      onKeyPress('c');
      onKeyPress('o');
      onKeyPress('m');
    } else {
      onKeyPress(key);
    }
  };

  return (
    <motion.div
      className="onscreen-keyboard-overlay"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      onClick={onClose}
    >
      <motion.div
        className="onscreen-keyboard"
        initial={{ y: 100, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        exit={{ y: 100, opacity: 0 }}
        transition={{ type: "spring", damping: 25, stiffness: 300 }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="keyboard-header">
          <h3>Email Keyboard</h3>
          <button className="keyboard-close" onClick={(e) => { e.stopPropagation(); onClose(); }}>×</button>
        </div>

        <div className="keyboard-text-display">
          <div className="keyboard-text-content">
            {currentText || 'Enter your email...'}
          </div>
        </div>

        <div className="keyboard-keys">
          {keys.map((row, rowIndex) => (
            <div key={rowIndex} className="keyboard-row">
              {row.map((key) => (
                <motion.button
                  key={key}
                  className={`keyboard-key ${
                    key === '⌫' ? 'backspace' :
                    key === '.com' ? 'com-key' :
                    key === 'OK' ? 'ok-key' :
                    key === '@gmail.com' || key === '@outlook.com' ? 'domain-key' : ''
                  }`}
                  onClick={(e) => handleKeyPress(key, e)}
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  transition={{ type: "spring", stiffness: 400, damping: 17 }}
                >
                  {key}
                </motion.button>
              ))}
            </div>
          ))}
        </div>
      </motion.div>
    </motion.div>
  );
};

export default OnScreenKeyboard;
